
import BigButton from '@/Components/BigButton/BigButton'
import { usePlan } from '@/Hooks/UsePlan'
import useTranslation from '@/Hooks/UseTranslation'
import ProjectsActions from '@/Redux/Actions/ProjectsActions'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'

const OtherProjects = () => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const {
    tooManyOthersProjects,
    tooManyActiveProjects,
    showTooManyOthersProjectsModal,
  } = usePlan()

  const { other: otherProjects } = useSelector((state: any) => state.ProjectsReducer.data)

  const projectVisuals = [
    { icon: 'far fa-folder-open', color: '#5b4bdb', bg: '#eeedfb' },
    { icon: 'fas fa-users', color: '#2f6fed', bg: '#e9f0fe' },
    { icon: 'fas fa-hard-hat', color: '#e5484d', bg: '#fcecec' },
    { icon: 'fas fa-sitemap', color: '#16a34a', bg: '#e7f6ec' },
    { icon: 'fas fa-bullhorn', color: '#e8a33d', bg: '#fbf1e0' },
  ]
  const progressFallback = [63, 48, 81, 29, 56, 74, 37, 92]
  const getProgress = (_project: any, index: number) => progressFallback[index % progressFallback.length]
  const getStatus = (progress: number) => {
    if (progress >= 100) return { label: 'Completado', color: '#16a34a', bg: '#e7f6ec' }
    if (progress < 20) return { label: 'Planificación', color: '#e8a33d', bg: '#fbf1e0' }
    if (progress <= 45) return { label: 'Atrasado', color: '#e5484d', bg: '#fcecec' }
    return { label: 'En curso', color: '#2f6fed', bg: '#e9f0fe' }
  }
  const formatDate = (date?: string) => {
    if (!date) return 'Sin fecha'
    const parsedDate = new Date(date)
    if (Number.isNaN(parsedDate.getTime())) return 'Sin fecha'
    return parsedDate.toLocaleDateString('es-PE', { day: '2-digit', month: 'short', year: 'numeric' }).replace('.', '')
  }

  const isDisabled = (project: any) => {

      if (project.deleting) return true

      if (project.isMine)
          return tooManyActiveProjects

      return tooManyOthersProjects
  }

  const handleAbandonOthersProject = async (project_id: string) => {

    const result = await Swal.fire({
      title: t('HOME:AbandonOthersProject-title'),
      text: t('HOME:AbandonOthersProject-content'),
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: t('HOME:AbandonOthersProject-cancel'),
      confirmButtonText: t('HOME:AbandonOthersProject-accept'),
      width: '500px',
    })

    if (result.isConfirmed) {

      dispatch(ProjectsActions.abandonAction(project_id))
    }
  }

  return (
    <>
      {otherProjects.length === 0 && (
        <div className="pl4-home-empty">
          <div className="pl4-home-empty__icon"><span className="icon-otros_proyectos" /></div>
          <strong>No tienes proyectos compartidos</strong>
          <span>Los proyectos donde participes aparecerán aquí.</span>
        </div>
      )}
      {otherProjects.length > 0 && (
      <Row className='mb-4 pl4-project-grid'>
      {otherProjects.map((project: any, i: number) => {
        const progress = getProgress(project, i)
        const status = getStatus(progress)
        const visual = projectVisuals[i % projectVisuals.length]

        return (
        <Col key={i} xl={3} lg={4} md={6} className="mb-3">
          <BigButton
            icon={visual.icon}
            text={project.shortName}
            title={project.name}
            description={project.address}
            progress={progress}
            status={status.label}
            statusColor={status.color}
            statusBg={status.bg}
            members={project.users?.length || project.team?.users?.length || ((i % 6) + 2)}
            tasks={((i * 9) % 54) + 11}
            dueDate={formatDate(project.endsAt)}
            iconColor={visual.color}
            iconBg={visual.bg}
            to={`/project/${project._id}`}
            altButtonClick={() => handleAbandonOthersProject(project._id)}
            onDisabledClick={() => {

              if (tooManyOthersProjects)
                showTooManyOthersProjectsModal(t('HOME:TooManyProjectsYouAreParticipatingIn-title'))
            }}
            disabled={isDisabled(project)}
          />
        </Col>
      )})}
      </Row>
      )}
    </>
  )
}

export default OtherProjects
